import {Select, MenuItem, InputLabel, FormControl} from '@material-ui/core';
import {Async, Empty, Loaded, toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect, useState} from 'react';
import {renderAsync} from 'Shared/components/RenderAsync';
import userApi from 'Users/api/userApi';
import {FieldSalesLeader} from 'Users/models/User/Agent/FieldSalesLeader';

const formatName = ({firstName, lastName}: FieldSalesLeader) => `${lastName}, ${firstName}`;

type FieldSalesLeaderSelectProps = {
  className?: string;
  fieldSalesLeaders: FieldSalesLeader[];
  onAddFieldSalesLeader: (fieldSalesLeader: FieldSalesLeader) => void;
  onRemoveFieldSalesLeader: (fieldSalesLeader: FieldSalesLeader) => void;
  disabled?: boolean;
};

const FieldSalesLeaderSelect = (props: FieldSalesLeaderSelectProps) => {
  const {fieldSalesLeaders, className, onAddFieldSalesLeader, onRemoveFieldSalesLeader, disabled} = props;
  const [availableFieldSalesLeadersAsync, setAvailableFieldSalesLeaders] = useState<Async<FieldSalesLeader[]>>(
    new Empty()
  );

  useEffect(() => {
    userApi.getAvailableSalesLeaders().then(availableFSLsResult =>
      pipe(
        availableFSLsResult,
        E.fold(
          error => setAvailableFieldSalesLeaders(error),
          availableFSLs => setAvailableFieldSalesLeaders(new Loaded(availableFSLs as FieldSalesLeader[]))
        )
      )
    );
  }, []);

  return pipe(
    availableFieldSalesLeadersAsync,
    toEither,
    E.fold(renderAsync, availableFSLs => (
      <FormControl className={className} variant="outlined" fullWidth>
        <InputLabel id="field-sales-leaders-select-label">Field Sales Leaders</InputLabel>
        <Select
          labelId="field-sales-leaders-select-label"
          multiple
          variant="outlined"
          labelWidth={150}
          value={fieldSalesLeaders.map(fsl => fsl.id!)}
          onChange={(e, menuItemEl) => {
            const selectedFSLId: string = (menuItemEl as any).props.value;
            const isAlreadySelected = fieldSalesLeaders.some(fsl => fsl.id === selectedFSLId);
            const selectedFSL = availableFSLs.find(fsl => fsl.id === selectedFSLId)!;

            if (isAlreadySelected) {
              onRemoveFieldSalesLeader(selectedFSL);
            } else {
              onAddFieldSalesLeader(selectedFSL);
            }
          }}
          disabled={!!disabled}
        >
          {availableFSLs.map(fsl => (
            <MenuItem value={fsl.id!}>{formatName(fsl)}</MenuItem>
          ))}
        </Select>
      </FormControl>
    ))
  );
};

export default FieldSalesLeaderSelect;
